import e, { useMemo as o } from "react";
import * as r from "@uploadcare/file-uploader";
import { g as u, u as f, C, A, a as U, b as E, j as x } from "./useIsBrowser-DhbB0Bdo.js";
r.defineComponents(r);
const I = x({
  react: e,
  tag: "uc-file-uploader-regular",
  elClass: r.FileUploaderRegular
}), F = ({
  ctxName: a,
  className: s,
  classNameUploader: l,
  apiRef: c,
  fallback: i,
  ...n
}) => {
  const t = o(() => a ?? r.UID.generate(), [a]), { eventHandlers: d, config: g, uploader: m } = o(
    () => u(n),
    [n]
  ), p = f();
  return /* @__PURE__ */ e.createElement(C, { condition: p, fallback: i }, /* @__PURE__ */ e.createElement("div", { className: s }, /* @__PURE__ */ e.createElement(A, { userAgentIntegration: U(), "ctx-name": t, ...g }), /* @__PURE__ */ e.createElement(
    E,
    {
      ref: c,
      "ctx-name": t,
      ...d
    }
  ), /* @__PURE__ */ e.createElement(I, { class: l, "ctx-name": t, ...m })));
};
export {
  F as FileUploaderRegular
};
